class PriceCalculator {
  constructor(
    unitPrice,
    quantity,
    merchantFeeRate,
    marketplaceFeeRate,
    gstRate
  ) {
    this.unitPrice = parseFloat(unitPrice);
    this.quantity = parseFloat(quantity);
    this.marketplaceFeeRate = parseFloat(marketplaceFeeRate);
    this.merchantFeeRate = parseFloat(merchantFeeRate);
    this.gstRate = parseFloat(gstRate);
  }

  subtotal() {
    let price = this.unitPrice * this.quantity;
    if (isNaN(price) || price < 0) {
      price = 0;
    }
    return price;
  }

  merchantFee() {
    let merchantFee = 0;
    if (!isNaN(this.merchantFeeRate) && this.merchantFeeRate > 0) {
      merchantFee =
        Math.ceil(parseFloat(this.subtotal() * this.merchantFeeRate) * 100) /
        100;
      if (isNaN(merchantFee) || merchantFee < 0) {
        merchantFee = 0;
      }
    }
    return merchantFee;
  }

  marketplaceFee() {
    let marketplaceFee = 0;
    if (!isNaN(this.marketplaceFeeRate) && this.marketplaceFeeRate > 0) {
      marketplaceFee =
        Math.ceil(parseFloat(this.subtotal() * this.marketplaceFeeRate) * 100) /
        100;
      if (isNaN(marketplaceFee) || marketplaceFee < 0) {
        marketplaceFee = 0;
      }
    }
    return marketplaceFee;
  }

  gst() {
    let gstValue = 0;
    if (!isNaN(this.gstRate) && this.gstRate > 0) {
      gstValue =
        Math.ceil(
          (this.subtotal() + this.marketplaceFee()) * this.gstRate * 100
        ) / 100;
      if (isNaN(gstValue) || gstValue < 0) {
        gstValue = 0;
      }
    }
    return gstValue;
  }

  totalChargeable() {
    return (this.subtotal() + this.marketplaceFee() + this.gst()).toFixed(2);
  }

  totalEarned() {
    return (this.subtotal() - this.merchantFee()).toFixed(2);
  }

  totalPayable() {
    return (this.subtotal() - this.merchantFee() + this.gst()).toFixed(2);
  }
}

export default PriceCalculator;



// WEBPACK FOOTER //
// ./src/javascripts/PriceCalculator.js